import { Spin } from 'antd'
import styled from 'styled-components'

export const StyledSpin = styled(Spin)`
    height: 100vh;
    max-height: 100vh !important;
    background: white;
`
